import Passenger from '../passenger/passenger'
export default class FlightOrder { // 航班订单类
  constructor(details = {}) {
    if (details) {
      for (let key of Object.keys(details)) {
        this[key] = details[key] ? JSON.parse(JSON.stringify(details[key])) : null
      }
    }
    this.AppointVettingPersonID = details && details.AppointVettingPersonID ? details.AppointVettingPersonID : '' // 选择的指定审批人ID
    this.AppointVettingPersonName = details && details.AppointVettingPersonName ? details.AppointVettingPersonName : '' // 选择的指定审批人姓名
    this.AuthorizationCode = details && details.AuthorizationCode ? details.AuthorizationCode : '' // 授权码
    this.ChangeReason = details && details.ChangeReason ? details.ChangeReason : '' // 改期原因
    this.CompanyPayType = details && details.CompanyPayType ? details.CompanyPayType : '' // 页面上传入，针对奔驰一家单位增加的
    this.Contacts = details && details.Contacts ? details.Contacts : [] // 联系人信息
    this.CustomItem = details && details.CustomItem ? details.CustomItem : null // 自定义项(所有乘客一样)
    this.DeliveryInfo = details && details.DeliveryInfo ? details.DeliveryInfo : null // 配送信息
    this.IsOA = details && details.IsOA ? details.IsOA : false // 是否OA订单
    this.IsCarryChild = details && details.IsCarryChild ? details.IsCarryChild : false // 是否带儿童
    this.IsCarryInfant = details && details.IsCarryInfant ? details.IsCarryInfant : false // 是否带婴儿
    this.OriginBookingID = details && details.OriginBookingID ? details.OriginBookingID : '' // 原订单ID(只有升舱改期的订单才会有值)
    this.OriginPnrID = details && details.OriginPnrID ? details.OriginPnrID : '' // 原pnr ID(只有升舱改期的订单才会有值)
    this.Passengers = details && details.Passengers ? this.setPassenger(details.Passengers) : [] // 常旅客
    this.PayType = details && details.PayType ? details.PayType : 0 // 支付类型
    this.Purpose = details && details.Purpose ? details.Purpose : '' // 差旅目的
    this.SegmentType = details && details.SegmentType ? details.SegmentType : 0 // 航段类型 0单段 1往返 2多段
    this.SelectedFlights = details && details.SelectedFlights ? details.SelectedFlights : [
      {
        LowestPriceFlight: {},
        ViolationCabinRankName: '',
        ViolationCabinRankReason: '',
        DepartCode: '',
        ArrivalCode: '',
        FlightNo: '',
        CabinID: '',
        DepartDate: this.beTime(new Date().setDate(new Date().getDate() + 1)),
        FlightDetails: {},
        CabinDetails: {}
      },
      {
        LowestPriceFlight: {},
        ViolationCabinRankName: '',
        ViolationCabinRankReason: '',
        DepartCode: '',
        ArrivalCode: '',
        FlightNo: '',
        CabinID: '',
        DepartDate: this.beTime(new Date().setDate(new Date().getDate() + 2)),
        FlightDetails: {},
        CabinDetails: {}
      }
    ] // 选择的航班信息
    this.TotalPrice = details && details.TotalPrice ? details.TotalPrice : 0 // 总价
    this.TravelType = details && details.TravelType ? details.TravelType : null // 旅游类型

    this.ExtendField1 = details && details.ExtendField1 ? details.ExtendField1 : '' // 扩展字段1
    this.ExtendField2 = details && details.ExtendField2 ? details.ExtendField2 : '' // 扩展字段2
    this.ExtendField3 = details && details.ExtendField3 ? details.ExtendField3 : '' // 扩展字段3
    this.ExtendField4 = details && details.ExtendField4 ? details.ExtendField4 : '' // 扩展字段4
    this.ExtendField5 = details && details.ExtendField5 ? details.ExtendField5 : '' // 扩展字段5

    this.AttachFiles = details && details.AttachFiles ? details.AttachFiles : [] // 上传图片

    /** 其他自定义参数, 便于下单流程中使用 | 这里与国际机票订单做区分, 国际第一段为1, 国内第一段为0 */
    this.RequestSegmentIndex = details && details.RequestSegmentIndex ? details.RequestSegmentIndex : 0
  }
  beTime(ms, format = 'yyyy-MM-dd') {
    let isDate = ms instanceof Date
    if (!isDate && `${ms}`.includes('-') && !`${ms}`.startsWith('-')) {
      let year = '1900'
      let month = '01'
      let day = '01'
      let hours = '00'
      let minutes = '00'
      let seconds = '00'
      let res = ''
      if (ms.includes(' ')) {
        let date = ms.split(' ')[0]
        year = date.split('-')[0]
        month = date.split('-')[1]
        day = date.split('-')[2]
        let time = ms.split(' ')[1]
        let timelist = time.split(':')
        timelist.length > 0 && (hours = timelist[0]);
        timelist.length > 1 && (minutes = timelist[1]);
        timelist.length > 2 && (seconds = timelist[1]);
        res = format.replace('yyyy', year).replace('MM', month).replace('dd', day).replace('hh', hours).replace('mm', minutes).replace('ss', seconds)
      } else {
        year = ms.split('-')[0]
        month = ms.split('-')[1]
        day = ms.split('-')[2]
        res = format.replace('yyyy', year).replace('MM', month).replace('dd', day)
      }
      return res
    } else {
      let date = ''
      if (isDate) {
        date = new Date(ms)
      } else {
        let val = ms.toString().length <= 10 ? ms * 1000 : ms
        date = new Date(val)
      }
      /** 将获取的日期格式转成北京时间 */
      // let currentDate = new Date()
      // let tmpMins = date.getMinutes()
      // let timeZone = currentDate.getTimezoneOffset() + 480
      // date = new Date(date.setMinutes(tmpMins + timeZone))
      /**********************************************************************************************/
      var fmt = format // yyyy-MM-dd hh:mm
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
      }
      let o = {
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds()
      }
      for (let k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
          let str = o[k] + ''
          fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : ('00' + str).substr(str.length))
        }
      }
      return fmt
    }
  }
  setPassenger(list = []) {
    let res = list.map(v => {
      return new Passenger(v)
    })
    return res
  }
}
